<div class="navbar-area navbar-style-two" stickyClass="sticky-box-shadow">
  <div class="container-fluid">
    <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
      <div *ngIf="coverPhotoUrl && (showCoverHeader || slug)" class="cover-hero"
        [style.--bg-image]="coverPhotoStyle"
        [attr.aria-label]="brandName + ' cover photo'">
          <img
            [src]="coverPhotoUrl"
            alt="Centered Image"
            class="cover-hero__center-image"
          />
        <div class="cover-hero__inner container-fluid">
          <div class="cover-hero__left leftGap">

            <div class="cover-hero__meta">
              <h1 class="cover-hero__title">
                <a class="navbar-brand" [routerLink]="routerLink" [queryParams]="queryParams">
                  <img class="cover-hero__logo" [src]="logoURL || fallbackLogo" [alt]="brandName"
                    (error)="useFallback($event)" />

                </a>
              </h1>

              <!-- <span *ngIf="!isVisbileTagLink" class="logo-heading logo_gap">{{ brandName }}</span> -->
            </div>
          </div>

          <div class="collapse navbar-collapse cover-hero__right" id="navbarSupportedContent">
            <ul class="navbar-nav rightGap">
              <li *ngIf="web_url" class="nav-item">
                <a [href]="web_url" target="_blank" class="nav-link">
                  <img src="../../../assets/img/webURL.png" alt="Visit Website" class="webURL" />
                </a>
              </li>
              <!-- <li class="nav-item" *ngIf="isLoggedIn">
                <a routerLink="/my-dashboard" href="javascript:void(0)" class="nav-link" routerLinkActive="active"
                  (click)="onClickMenu('/my-dashboard')"><i class='bx bx-user'></i>
                  {{resource.dashboard}}</a>
              </li> -->
              
              <!-- <li class="nav-item"><a routerLink="/contact" href="javascript:void(0)" class="nav-link"
                  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                  (click)="onClickMenu('/contact')"><i class='bx bx-envelope'></i>
                  {{resource.contact_us}}</a></li> -->
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>